import { AssignmentInd, DirectionsRun, HourglassEmpty, Cancel, Error, CheckCircle } from "@mui/icons-material";
import { alpha, Chip, SvgIconProps } from "@mui/material";
import { blue, orange, red, green, grey } from "@mui/material/colors";
import { chipOpacity, chipPadding } from "./common";
import { DeliveryBatchState, OrderDeliveryTaskState } from "../../../enums/tasks";
import ReplayIcon from '@mui/icons-material/Replay';

export const getDeliveryTaskStateColor = (state: OrderDeliveryTaskState): string => {
    switch (state) {
        case OrderDeliveryTaskState.IN_PROGRESS:
            return alpha(blue[500], chipOpacity);
        case OrderDeliveryTaskState.AWAITING_RETURN:
            return alpha(orange[700], chipOpacity);
        case OrderDeliveryTaskState.COMPLETED:
            return alpha(green[500], chipOpacity);
        case OrderDeliveryTaskState.FAILED:
            return alpha(red[500], chipOpacity);
        default:
            return alpha(grey[500], chipOpacity);
    }
};

export const getDeliveryTaskStateIcon = (state: OrderDeliveryTaskState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: "small", color: "inherit" };

    switch (state) {
        case OrderDeliveryTaskState.SCHEDULED:
            return <AssignmentInd {...iconProps} />;
        case OrderDeliveryTaskState.OUT_FOR_DELIVERY:
            return <DirectionsRun {...iconProps} />;
        case OrderDeliveryTaskState.IN_PROGRESS:
            return <HourglassEmpty {...iconProps} />;
        case OrderDeliveryTaskState.COMPLETED:
            return <CheckCircle {...iconProps} />;
        case OrderDeliveryTaskState.AWAITING_RETURN:
            return <ReplayIcon {...iconProps} />;
        case OrderDeliveryTaskState.FAILED:
            return <Error {...iconProps} />;
    }
};

export const showDeliveryTaskState = (state: OrderDeliveryTaskState): JSX.Element => {
    return (
        <Chip
            icon={getDeliveryTaskStateIcon(state)}
            label={<b>{state.toString().replaceAll("_", " ")}</b>}
            variant="filled"
            style={{
                margin: 4,
                padding: chipPadding,
                backgroundColor: getDeliveryTaskStateColor(state),
            }}
        />
    );
};
